import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["href", "external", "target", "rel", "download", "active", "noRouterLink", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import DixuText from "../DixuText/DixuText";
import Link from 'next/link';
import React, { forwardRef } from 'react';
import { isStorybookEnv } from "../../utils/EnvUtils";
const DixuLink = _ref => {
  let {
      href,
      external,
      target,
      rel,
      download,
      active,
      noRouterLink,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-link', {
    'dixu-link--active': active
  }, className);
  const noLink = noRouterLink || isStorybookEnv || external || download || !href || /^(#|tel:|mailto:)/.test(href);
  const passedProps = (() => {
    const props = {
      inner: _objectSpread(_objectSpread({}, rest), {}, {
        href,
        target,
        rel,
        download,
        className: classes,
        tag: 'a'
      }),
      wrapper: _objectSpread(_objectSpread({}, rest), {}, {
        href,
        passHref: true
      })
    };
    if (external) {
      props.inner.target = target || '_blank';
      props.inner.rel = ['noopener noreferrer', rel].filter(Boolean).join(' ');
    }
    return props;
  })();

  // Need forwardRef to avoid NextJS errors.
  const InnerLink = /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({}, passedProps.inner), props), children);
  });
  if (noLink) {
    return /*#__PURE__*/React.createElement(InnerLink, null);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({}, _objectSpread({}, passedProps.wrapper), {
    passHref: true,
    legacyBehavior: true
  }), /*#__PURE__*/React.createElement(InnerLink, null));
};
DixuLink.defaultProps = {
  external: false,
  active: false,
  noRouterLink: false
};
export default DixuLink;